export const NO_CONTENT = '\u2013';
